import { useEffect, useState, useCallback } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const { refresh } = useAuth();

  const check = useCallback(async () => {
    if (!sessionId) return;
    try {
      const { data } = await api.get(`/payments/status/${sessionId}`);
      setStatus(data);
      if (data.payment_status === "paid") {
        refresh();
        return true;
      }
    } catch {}
    return false;
  }, [sessionId, refresh]);

  useEffect(() => {
    let stop = false;
    const loop = async () => {
      const done = await check();
      if (!done && !stop && attempts < 15) {
        setTimeout(() => setAttempts((a) => a + 1), 2000);
      }
    };
    loop();
    return () => { stop = true; };
  }, [attempts, check]);

  const isPaid = status?.payment_status === "paid";
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="payment-success-page">
        {isPaid ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto" />
            <h1 className="mt-4 font-display text-3xl font-bold text-white">Pagamento confirmado!</h1>
            <p className="mt-2 text-slate-400">Recebemos {status.credits} créditos na sua conta.</p>
            <Link to="/search"><Button className="mt-6 bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold">Começar a pesquisar</Button></Link>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-emerald-400 mx-auto animate-spin" />
            <h1 className="mt-4 font-display text-2xl font-bold text-white">Confirmando pagamento...</h1>
            <p className="mt-2 text-slate-400 text-sm">Aguarde alguns segundos.</p>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <XCircle className="w-16 h-16 text-red-400 mx-auto" />
        <h1 className="mt-4 font-display text-3xl font-bold text-white">Pagamento cancelado</h1>
        <p className="mt-2 text-slate-400">Sem cobranças. Você pode tentar novamente quando quiser.</p>
        <Link to="/store"><Button className="mt-6 bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold">Voltar à loja</Button></Link>
      </div>
    </div>
  );
}
